import React from "react";
import Grid from "@mui/material/Grid";
import TextInputComponent from "../../ui/TextInputComponent";
import SelectInputComponent from "../../ui/SelectInputComponent";


const MarketingContactStep = ({ formData = {}, errors, handleChange }) => {
  return (
    <Grid container spacing={2}>
      {/* Contact Info */}
      <Grid item xs={12} md={4}>
        <TextInputComponent
          label="Contact Name"
          value={formData.contactName}
          onChange={handleChange("contactName")}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <TextInputComponent
          label="Contact Email"
          value={formData.contactEmail}
          onChange={handleChange("contactEmail")}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <TextInputComponent
          label="Contact Phone"
          value={formData.contactPhone}
          onChange={handleChange("contactPhone")}
        />
      </Grid>

      {/* Internal Notes */}
      <Grid item xs={12}>
        <TextInputComponent
          label="Internal Notes"
          value={formData.internalNotes}
          onChange={handleChange("internalNotes")}
          multiline
          rows={4}
        />
      </Grid>

      {/* RSVPs & Tags */}
      <Grid item xs={12} md={6}>
        <SelectInputComponent
          label="Allow RSVPs"
          value={formData.allowRsvps}
          onChange={handleChange("allowRsvps")}
          options={[
            { label: "Yes", value: true },
            { label: "No", value: false },
          ]}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextInputComponent
          label="Event Tags (comma-separated)"
          value={formData.tags}
          onChange={handleChange("tags")}
        />
      </Grid>

      {/* Public Visibility */}
      <Grid item xs={12} md={6}>
        <SelectInputComponent
          label="Visible to Public"
          value={formData.visibleToPublic}
          onChange={handleChange("visibleToPublic")}
          options={[
            { label: "Yes", value: true },
            { label: "No", value: false },
          ]}
        />
      </Grid>
    </Grid>
  );
};

export default MarketingContactStep;
